function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { getLoginBaseURL } from '@finect/front-utils/getLoginBaseURL';
var defaultCopy = 'Para realizar esta acción accede a tu cuenta de Finect';
var loginBaseURL = getLoginBaseURL();
var copies = {
  subscribe: {
    product: 'Para suscribirte a un producto accede a tu cuenta de Finect',
    profile: defaultCopy,
    article: 'Para suscribirte a un artículo accede a tu cuenta de Finect'
  },
  comment: {
    article: 'Para comentar un artículo accede a tu cuenta de Finect'
  },
  like: {
    product: defaultCopy,
    profile: defaultCopy,
    article: defaultCopy
  }
};
export var getAction = function getAction(entityType, actionType, id, next) {
  var blob = {
    copy: copies[actionType] && copies[actionType][entityType] ? copies[actionType][entityType] : defaultCopy,
    action: actionType,
    target: {
      type: entityType,
      id: id
    }
  };
  return next ? _objectSpread(_objectSpread({}, blob), {
    next: next
  }) : blob;
};
export var getBlobAction = function getBlobAction(action) {
  return Buffer.from(JSON.stringify(action)).toString('base64');
};
export var getLoginURL = function getLoginURL(entityType, actionType, id, next) {
  var defaultNext = window ? window.location.href : null;
  var action = getAction(entityType, actionType, id, next || defaultNext);
  return "".concat(loginBaseURL, "/login?action=").concat(getBlobAction(action));
};
export var loginAction = function loginAction(entityType, actionType, id, next) {
  window.location = getLoginURL(entityType, actionType, id, next || null);
};
export var goToLoginWithAction = function goToLoginWithAction(action) {
  var url = "".concat(loginBaseURL, "/login?action=").concat(getBlobAction(action));
  window.location = url;
};